import React from "react";
import IngredientList from "../components/Ingredients/IngredientList";
import AddIngredientForm from "../components/Ingredients/AddIngredientForm";

const IngredientsPage = () => {
    return (
        <div>
            <IngredientList />
        </div>
    );
};

export default IngredientsPage;
